// Single source of truth for HH:MM parsing. Three call sites (notifications,
// nativeNotifications, calendarExport) used to each carry their own copy with
// slightly different strictness; this one is strict so callers never have to
// worry about smuggled "8:0" / "24:99" / "" values past the parser.

import type { ReminderTimes } from './db';

const HHMM = /^([01]\d|2[0-3]):([0-5]\d)$/;

export interface HourMinute {
  hour: number;
  minute: number;
}

export function parseHm(time: string | undefined | null): HourMinute | null {
  if (!time) return null;
  const match = HHMM.exec(time);
  if (!match) return null;
  return { hour: Number(match[1]), minute: Number(match[2]) };
}

export function isValidHm(time: string | undefined | null): boolean {
  return parseHm(time) !== null;
}

/**
 * The 10th-step nightly review piggybacks on the evening check-in time. If
 * none is configured (or it's malformed/empty), fall back to 21:00. Centralized
 * here so notifications, native scheduling, and the .ics builder agree.
 */
export function getTenthStepCutoff(reminderTimes: ReminderTimes): string {
  const evening = reminderTimes.evening;
  if (evening && isValidHm(evening)) return evening;
  return '21:00';
}
